import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react"
import {useMutation} from "@apollo/client"
import {useLocation} from "react-router-dom"

import deviceAuthApprove from "graphql/User/mutation/deviceAuthApprove"
import {userContext} from "context/User"

export const DeviceAuthRoute = () => {
  const location = useLocation()
  const user = useContext(userContext)
  const codeFromURL = useMemo(() => {
    const value = new URLSearchParams(location.search).get("code") || ""
    return value.replace(/\D/g, "").slice(0, 6)
  }, [location.search])

  const [code, setCode] = useState(codeFromURL)
  const [message, setMessage] = useState("")
  const [approve, {loading}] = useMutation(deviceAuthApprove)
  const automaticallyAttemptedCode = useRef("")

  const approveCode = useCallback(async (value: string) => {
    setMessage("")

    try {
      await approve({variables: {code: value.replace(/\s/g, "")}})
      setMessage("Apple TV connectée. Vous pouvez revenir sur votre télévision.")
    } catch (error) {
      setMessage("Code invalide ou expiré.")
    }
  }, [approve])

  useEffect(() => {
    setCode(codeFromURL)
  }, [codeFromURL])

  useEffect(() => {
    if (!user || codeFromURL.length !== 6 || automaticallyAttemptedCode.current === codeFromURL) return
    automaticallyAttemptedCode.current = codeFromURL
    void approveCode(codeFromURL)
  }, [approveCode, codeFromURL, user])

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    await approveCode(code)
  }

  return <div className="device-auth-route">
    <h1>Connecter une Apple TV</h1>
    <p>{codeFromURL.length === 6
      ? "Code détecté depuis le QR code. La connexion va être validée automatiquement."
      : "Saisissez le code à six chiffres affiché sur votre télévision."}</p>
    <form className="input-group" onSubmit={submit}>
      <input
        className="form-control"
        autoComplete="one-time-code"
        inputMode="numeric"
        maxLength={6}
        placeholder="000000"
        value={code}
        onChange={event => setCode(event.target.value.replace(/\D/g, ""))}
      />
      <span className="input-group-append">
        <button className="btn btn-dark" disabled={loading || code.length !== 6} type="submit">
          {loading ? "Connexion…" : "Connecter"}
        </button>
      </span>
    </form>
    {message && <div className="alert alert-dark" style={{marginTop: 20}}>{message}</div>}
  </div>
}
